import { render, staticRenderFns } from "./StartNavbar.vue?vue&type=template&id=2f46b816&"
import script from "./StartNavbar.vue?vue&type=script&lang=js&"
export * from "./StartNavbar.vue?vue&type=script&lang=js&"
import style0 from "./StartNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports